import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import About from '@/components/About';
import Activities from '@/components/Activities';
import Service from '@/components/Service';
import Album from '@/components/Album';
import Contact from '@/components/Contact';
import ActivityDetail from '@/components/ActivityDetail';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/about',
      name: 'About',
      component: About,
    },
    {
      path: '/activities',
      redirect: '/activities/training',
      name: 'ActivitiesIndex',
      component: Activities,
    },
    {
      path: '/activities/:type',
      name: 'Activities',
      component: Activities,
    },
    {
      path: '/activities/:category/:activityId',
      name: 'ActivityDetail',
      component: ActivityDetail,
    },
    {
      path: '/service',
      name: 'Service',
      component: Service,
    },
    {
      path: '/album',
      name: 'Album',
      component: Album,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js